<div class="view-component-body">

    <ngx-datatable #dynamicTable class="material striped server-scrolling" name="datatable-body"
                  [rows]="rows" 
                  [headerHeight]="headerHeight"
                  [rowHeight]="rowHeight"
                  [messages]="{'emptyMessage':'Não encontrado dados.','totalMessage': 'total'}"
                  [reorderable]="true"
                  [swapColumns]="false"
                  [scrollbarH] = "true"
                  [scrollbarV]="true"
                  [selected]="selectedRow"
                  [selectionType]="SelectionType.single"
                  (activate)="eventGrid($event)"
                  [loadingIndicator]="loadingIndicator"
                  >
                  

                  <ngx-datatable-column  *ngFor="let col of columns" [name]="col.name" [prop]="col.prop" >
                  </ngx-datatable-column>
              </ngx-datatable>
              
</div>